import { createReducer } from 'typesafe-actions'
import { LoadingStateEnum } from '../../types'
import {
  getFireblocksAssetBySymbolFailure,
  getFireblocksAssetBySymbolRequest,
  getFireblocksAssetBySymbolSuccess,
  FireblocksTarget,
  clearFireblocksByTarget,
  clearFireblocksAll,
} from '../actions'
import { ActionTypes } from '../types'

export type FireblocksAsset = {
  id: string
  name: string
  displayName?: string
  legacyId?: string
  displaySymbol?: string
  iconUrl?: string
}

type SliceState = {
  loading: LoadingStateEnum
  data: FireblocksAsset[]
  error: Error | null
}

export type FireblocksState = {
  base: SliceState
  quote: SliceState
}

const initialSlice: SliceState = {
  loading: LoadingStateEnum.IDLE,
  data: [],
  error: null,
}

export const initialState: FireblocksState = {
  base: { ...initialSlice },
  quote: { ...initialSlice },
}

const pick = (target: FireblocksTarget, state: FireblocksState) => (target === 'base' ? state.base : state.quote)

export const fireblocks = createReducer<FireblocksState, ActionTypes>(initialState)
  .handleAction(getFireblocksAssetBySymbolRequest, (state, { payload: { target } }) => ({
    ...state,
    [target]: {
      ...pick(target, state),
      loading: LoadingStateEnum.LOADING,
      error: null,
    },
  }))
  .handleAction(getFireblocksAssetBySymbolSuccess, (state, { payload: { assets, target } }) => ({
    ...state,
    [target]: {
      ...pick(target, state),
      loading: LoadingStateEnum.SUCCESS,
      data: assets,
    },
  }))
  .handleAction(getFireblocksAssetBySymbolFailure, (state, { payload: { error, target } }) => ({
    ...state,
    [target]: {
      ...pick(target, state),
      loading: LoadingStateEnum.ERROR,
      data: [],
      error,
    },
  }))
  .handleAction(clearFireblocksByTarget, (state, { payload: { target } }) => ({
    ...state,
    [target]: { ...initialSlice },
  }))
  .handleAction(clearFireblocksAll, () => ({ ...initialState }))
